import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Modal } from 'antd';
import { BulbTwoTone, UnlockTwoTone, ImportOutlined, LoginOutlined, DoubleRightOutlined, QuestionCircleOutlined, UserAddOutlined, KeyOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import Layout, { Content, Footer, Header } from 'antd/lib/layout/layout'
import { InputX, NumberX, _Button } from '../services/Forms/Forms';
import { globalText } from '../services/Text/GlobalText';
import { acakText } from '../services/Crypto';
// import _Api from '../services/Api/_ApiBase';
import { _Toastr, msg } from '../services/Toastr/Notify/_Toastr';
import { LogOut } from '.';
// import _ApiBase from '../services/Api/_ApiBase';
import axios from 'axios';
import { baseURL_R } from '../services/BaseUrl';
import MainLayouts from '../layouts/MainLayouts';
import { Col, Row } from 'react-bootstrap';
import REST from '../services/Api/REST';

// import logo from "/assets/img/logo.png"


function RegisterAuth() {

    const [username, setUsername] = useState()
    const [password, setpassword] = useState()
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    const [frmreg] = Form.useForm()

    const history = useHistory()

    const gotoLogin = () => {
        history.push("/login")
    }


    useEffect(() => {
        setLoading(false)
        LogOut();
    }, [])

    const kirimOTP = () => {

        var nohp = parseInt(frmreg.getFieldValue('nohp'))

        // var obj = {
        //     "phone" :"6285333001601",
        //     "message": "Kode OTP anda:\n04556\nHarap di jaga"
        // }
        // axios.post("http://172.16.0.76:8002/send/message", obj).then(res=>{
        //     console.log(res)
        //     debugger
        // })
    }
    const registerAkunBaru = (val) => {
        try {
            const pass = frmreg.getFieldValue('password')
            const passlagi = frmreg.getFieldValue('password_lagi')
            if( pass != passlagi ){
                msg.error('Password tidak cocok !')
                return
            }
            REST.post("register-akun-baru", val).then(res => {
                msg.auto(res.data)
                if(res.data.sts == 1){
                    gotoLogin()
                }
            })


        } catch (error) {
            setLoading(false)
            _Toastr.error("Gagal terhubung ke server, Periksa jaringan anda ...")
        }
    }


    return (
        <MainLayouts >
            <div style={{ width: "100%", padding: "0px 10%" }}>
                <h1 style={{ textAlign: "center", marginTop: "8%" }}></h1>
                <div style={{ textAlign: "center" }}>
                    <p><img width="250" src={"/img/logo.png"} alt="" /></p>
                    <p style={{ textAlign: "center", fontWeight: "bolder", fontSize: "20px" }}> <span style={{ color: "#ff4d4f" }}>
                        BUAT AKUN </span>    </p>

                    {/* <b> Silahkan Login </b> */}
                </div>
                <Row>
                    <center>
                        <Form layout='vertical' method='POST' form={frmreg} onFinish={registerAkunBaru} >
                            <InputX min={10} message="Minimal 10 angka" name="nohp" required label="No. HP" sm="6" />
                            {/* <_Button sm="2" label="Kirim OTP" onClick={kirimOTP}  block/>
                            <InputX name="kodeotp"  label="Verifikasi OTP" sm="3" />
                            <_Button sm="2" label="Cek OTP" /> */}
                            <InputX required name="namalengkap" label="Nama Lengkap " sm="6" />
                            <InputX name="alamatlengkap" label="Alamat Lengkap " multiline sm="6" />
                            <br/>
                            <hr/>
                            <h5> User & Password </h5>
                            <InputX required name="password" min={6} message="Minimal 6 karakter"  password label="Password" sm="6" />
                            <InputX required name="password_lagi" password label="Password Lagi" min={6} message="Minimal 6 karakter"  sm="6" />
                            <Button htmlType='submit'> Simpan </Button>
                        </Form>
                    </center>
                </Row>
                <br />
                <center>
                    <Button onClick={gotoLogin} type="link" icon={<KeyOutlined />} > <b> Login </b></Button>
                </center>
            </div>


        </MainLayouts>

    )
}

export default RegisterAuth
